<template>
  <Header/>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast/>

          <div>
            <Card class="mb-4 pt-3">
              <template #title>
                <div class="me-3 d-flex align-items-center">
                  <button class="p-button-primary p-button btn d-flex justify-content-evenly gap-2" @click="goBack"><i class="fa-solid fa-left-to-line fw-bold"></i> <span class="fw-bold">Report list</span></button>
                </div>
              </template>
              <template #content>
                <div class="d-flex flex-column">
                  <div>
                    <div class="d-flex align-items-end w-100 gap-3">
                      <div class="w-100">
                        <label for="user-id-input" class="form-label">Image Path</label>
                        <input
                            id="imageUrl"
                            placeholder="Image Path"
                            v-model="data.imageUrl"
                            type="text"
                            style="padding-top: 15px !important;padding-left: 18px !important;padding-bottom: 15px !important;"
                            class="form-control w-100" />
                      </div>
                      <div class="w-100">
                        <label for="user-id-input" class="form-label">Order</label>
                        <input
                            id="order"
                            placeholder="Order"
                            v-model="data.order"
                            type="number"
                            style="padding-top: 15px !important;padding-left: 18px !important;padding-bottom: 15px !important;"
                            class="form-control w-100" />
                      </div>
                    </div>
                    <button type="button" class="btn pb-5" @click="addProperty">+ Add rag image</button>


                    <div v-for="(item, index) in arrayData" :key="index" class="d-flex gap-2 mt-2 align-items-center">
                      <span>{{ item }}</span>
                      <button type="button" class="btn btn-danger" @click="removeFromArray(index)">Sil</button>
                    </div>
                  </div>

                  <div class="mt-3">
                    <button
                        class="p-button p-component p-button-info"
                        style="border-radius: 0.5em;"
                        @click="createObj"
                    >
                      Save
                    </button>
                  </div>


                </div>
              </template>
            </Card>

          </div>

          <div class="mb-3 mt-3 d-flex align-items-center gap-2">
            <span>Report images delete: </span><button @click="deleteSee" class="p-button p-component p-button-danger">Delete</button>
          </div>

          <AstopiaTable ref="astopiaTable" :columns="columns" :url="'/admin/rag/list/images/'"
                        :default-post-data="this.$route.params.id + '?language=' + this.$route.params.language"
                        :axiosDataName="'response'" :sort-field="''" :totalDataName="'totalRecords'"
                        @detail-see="detailSee" @detail-see2="detailSee2" @delet-see="deleteSee" @add-button="addPublicFigure" :addButton="false" :goBackButton="false" :dataPagination="false" :optionsList="optionsList" :selectedObj3="false"/>

          <EditModal
              :show="showEditModal"
              modalTitle="Edit Rag"
              modalWidth="50%"
              :formFields="[
                { label: 'Language', type: 'select', model: 'language', options: optionsList, value: 'id', text: 'name', required: true},
                { label: 'imageUrl', type: 'text', model: 'imageUrl', placeholder: 'Enter imageUrl', required: true },
                { label: 'order', type: 'text', model: 'order', placeholder: 'Enter order', required: true },
                { label: 'report', type: 'text', model: 'report', placeholder: 'Enter report', required: true }
              ]"
              :detailData="selectedObj"
              @saveEndpoint="editObj"
              method="put"
              :totalDataName="'data'"
              :isOnlydata="true"
              @hide="showEditModal = false"
          />

          <DeleteModal
              :show="showDeleteModal"
              :itemId="selectedDeleteId"
              modalTitle="Delete Rag"
              deleteMessage="Are you sure you want to delete these report images?"
              confirmButtonText="Yes"
              :deleteEndpoint="`/admin/rag/delete/images/${parseInt(this.$route.params.id)}`"
              @update:isVisible="showDeleteModal = false"
              @delete-success="refreshTable"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import AstopiaTable from "@/components/Tables/AstopiaTable.vue";
import dayjs from "dayjs";
import "@vuepic/vue-datepicker/dist/main.css";
import Toast from 'primevue/toast';
import {mapGetters} from "vuex";
import dist from "vue-sweetalert2/dist";

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

export default {
  name: "Users",
  components: {
    Header,
    Toast,
    AstopiaTable
  },
  data() {
    const schema = {
      price: "required|numeric|regex",
    };

    return {
      loading: false,
      totalRecords: 0,
      content: [],
      filters: {
        global: {value: null},
        name: {value: null},
        isPublicFigure: {value: true}
      },
      contentLazyParams: {},
      schema,
      houses: [],
      signs: [],
      genders: [{id: 1, name: "Man"}, {id: 2, name: "Woman"}, {id: 3, name: "Other"}],
      selectedObj: null,
      showEditBirthdateModal: false,
      selectedObjId: null,
      showEditModal: false,
      showCreateModal: false,
      showDeleteModal: false,
      selectedDeleteId: null,
      editUserModel: {},
      messages: [],
      messageCount: 0,
      saveButtonLoading: false,
      showPublicFigureModal: false,
      newPublicFigureModel: {},
      countries: [],
      cities: [],
      states: [],
      optionsList: [],
      ragList: [],
      columns: [
        {field: "report", header: "Report", functionType: "none", selected: true},
        {field: "imageUrl", header: "Image Url", functionType: "none", selected: true},
        {field: "order", header: "Order", functionType: "none", selected: true},
        {field: "language", header: "Language", functionType: "none", selected: true},
        {field: "Actions", header: "Actions", functionType: "crud", edit: true, delete: false, selected: true},
      ],
      arrayData: [],
      data:{
        "language": this.$route.params.language,
        "order": 0,
        "imageUrl": ""
      },
      dataUpdate:[
        {
          "language": this.$route.params.language,
          "order": 0,
          "imageUrl": "string"
        }
      ]
    };
  },
  created() {
    this.$appAxios.get("admin/global/supported-languages")
        .then(resp => {
          this.optionsList = resp.data
        })
        .catch(err => {
          console.log(err)
        });

    this.$appAxios.get("/admin/rag/list/images/" + this.$route.params.id + '?language=' + this.$route.params.language).then((res) => {
      console.log("res",res)
      this.ragList = res.data.response;
    });

  },
  computed: {
    dist() {
      return dist
    },
    ...mapGetters(['occupations', 'signs', 'houses', 'relationships', 'occupationIds', 'relationshipIds']),
  },
  methods: {
    openEditModal(rowData) {
      this.editUserModel = rowData;
      this.showEditBirthdateModal = true;
    },
    addProperty() {
      this.arrayData.push(this.data);
      this.data = {};
    },
    removeFromArray(index) {
      this.arrayData.splice(index, 1);
    },
    deleteSee(report) {
      this.selectedDeleteId = report.id

      this.showDeleteModal = true
    },
    detailSee(obj) {
      this.selectedObjId = obj.id
      this.selectedObj = obj || null;
      this.showEditModal = true
    },
    detailSee2(obj){
      this.$router.push({name:"ReportImages", params:{id:obj.id}})
    },
    editObj(obj) {
      const updatedId = obj?.id;

      this.dataUpdate = this.ragList.map(item =>
          item.id === updatedId
              ? { ...item, language: obj?.language, order: obj?.order, imageUrl: obj?.imageUrl }
              : item
      );

      const headers = {
        "Accept-Language": obj?.language,
      };

      this.$appAxios.put(`admin/rag/update/images/${parseInt(this.$route.params.id)}`, this.dataUpdate, { headers })
          .then(() => {
            this.refreshTable();
            this.showEditModal = false;
          })
          .catch(err => {
            console.log(err);
            this.showEditModal = false;
          });
    },
    createObj() {
      this.$appAxios.post(`/admin/rag/create/images/${parseInt(this.$route.params.id)}`, this.arrayData).then(() => {
        this.refreshTable()
        this.showCreateModal = false
      }).catch(() => {
        this.showCreateModal = false
      })
    },
    addPublicFigure() {
      this.showCreateModal = true
    },
    refreshTable() {
      this.$refs.astopiaTable.getData();
      this.$refs.astopiaTable.getObj();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.p-button-sm {
  height: 35px;
  width: 35px;
  font-size: 0.875rem;
  padding: 0.7rem;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.8;
}

.p-dropdown {
  min-width: 200px;
}
</style>